import { withStyles } from '@material-ui/core/styles';
import BackToTop from './BackToTop';
import styles from './BackToTop.styles';

export default withStyles(styles)(BackToTop);
